import React from 'react';
import type { GlobalAttributesT, XstyledProps } from '@elliemae/ds-props-helpers';
import {
  useGetGlobalAttributes,
  useGetXstyledProps,
  useMemoMergePropsWithDefault,
  useValidateTypescriptPropTypes,
} from '@elliemae/ds-props-helpers';
import { propTypes, defaultProps, type DSFormLayoutBlockItemT } from '../react-desc-prop-types.js';
import { DSFormLayoutBlockItemName } from '../DSFormLayoutBlockItemDefinitions.js';

interface UseFormLayoutBlockItemT {
  propsWithDefault: DSFormLayoutBlockItemT.InternalProps;
  globalAttributes: GlobalAttributesT;
  xstyledProps: XstyledProps;
}

export const useFormLayoutBlockItem = (props: DSFormLayoutBlockItemT.Props): UseFormLayoutBlockItemT => {
  useValidateTypescriptPropTypes(props, propTypes, DSFormLayoutBlockItemName);
  const propsWithDefault = useMemoMergePropsWithDefault<DSFormLayoutBlockItemT.InternalProps>(props, defaultProps);
  const globalAttributes = useGetGlobalAttributes(propsWithDefault);

  const xstyledProps = useGetXstyledProps(propsWithDefault);
  return React.useMemo(
    () => ({ globalAttributes, xstyledProps, propsWithDefault }),
    [globalAttributes, xstyledProps, propsWithDefault],
  );
};
